<template>
<div class='tableScope tra-fast posR'>
  <div class='table table-5x cb'>
     <div class="scrollHide tra-fast fL"
         :style="{'width':stage.setting.system.autoColumnWidth[0]*floatColumn.length+stage.setting.system.autoColumnWidth[1]}"
         scrollFloatX="false"
         >
      <div class="tableSys head noSelect b cField bdLight-bottom tra-fast_E" scrollFloatY="false">
        <div class="sequence" :class='{cMain: this.name}' @click='sortList("name")'>{{getLanguageStr("word1719","子系统名称")}}<span :sequence="name"></span></div>
      </div>
      <div class="fixedScrollBar scrollY tra-fast h15x"
           scroll="{'group':'generationName'}">
        <table>
          <thead class="head-token">
            <tr>
              <th></th>
            </tr>
          </thead>
          <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
            <tr class="curP pl2x-imp"
                v-for="(item, index) in data"
                :key="index"
                @click="clickName(item)"
                >
              <td :title="item.name">{{item.name}}</td>

            </tr>
          </tbody>
        </table>
      </div>
    </div>
   <div scroll="{'axis':'x'}">
        <div class="tableSys head noSelect b cField bdLight-bottom" :style="{
              'min-width':
              stage.setting.system.autoColumnWidth[0] * column.length + stage.setting.system.autoColumnWidth[1],
          }" scrollFloatY="false">
        
          <div class="taL sequence" :title="getLanguageStr('plant_detail133', '通讯状态')">
            {{ getLanguageStr("plant_detail133", "通讯状态") }}
          </div>
          <div class="taL sequence " :title="getLanguageStr('plant_detail183', '报警状态')">
            <span>{{ getLanguageStr("plant_detail183", "报警状态")}}</span>
          </div>
          <div class="taL sequence " :class='{cMain: this.generationPower}' @click='sortList("generationPower")' :title="getLanguageStr('word176', '发电功率')+'(W)'">
            <span>{{ getLanguageStr("word176", "发电功率")+'(kW)'}}</span>
             <span :sequence="generationPower"></span>
          </div>
          <div class="taL sequence " :class='{cMain: this.generationValue}' @click='sortList("generationValue")' :title="getLanguageStr('word358', '当日发电量')+'(kWh)'">
            <span>{{ getLanguageStr("word358", "当日发电量")+'(kWh)'}}</span>
            <span :sequence="generationValue"></span>
          </div>
          <div class="taL sequence " :class='{cMain: this.generationUploadTotalOffset}' @click='sortList("generationUploadTotalOffset")' :title="getLanguageStr('fullscreen7', '累计发电量')+'(kWh)'">
            <span>{{ getLanguageStr("fullscreen7", "累计发电量")+'(kWh)'}}</span>
            <span :sequence="generationUploadTotalOffset"></span>
          </div>
          <div class="taL sequence " :class='{cMain: this.fullPowerHoursDay}' @click='sortList("fullPowerHoursDay")' :title="getLanguageStr('device_management78', '当日满发小时')+'(h)'">
           
            <span>{{ getLanguageStr("device_management78", "当日满发小时")+'(kWh)'}}</span>
             
            <span :sequence="fullPowerHoursDay"></span>
            <Help  :code="'full_power_hours_day1'" :btnClose="false" class="ml05x"></Help>
          </div>
          <div class="taL sequence " :class='{cMain: this.generationCapacity}' @click='sortList("generationCapacity")' :title="getLanguageStr('plant_list8', '功率归一化')">
          
            <span>{{ getLanguageStr("plant_list8", "功率归一化")}}</span>
              
            <span :sequence="generationCapacity"></span>
            <Help  :code="'allforone'" :btnClose="false" class="ml05x"></Help>
          </div>
          <div class="taL sequence" :class='{cMain: this.installedCapacity}' @click='sortList("installedCapacity")' :title="getLanguageStr('plant_detail261', '装机容量')+'(kWp)'">
            <span>{{ getLanguageStr("plant_detail261", "装机容量")+'(kWp)'}}</span>
            <span :sequence="installedCapacity"></span>
          </div>
        </div>
        <div class="fixedScrollBar scrollY tra-fast h15x" scroll="{'group':'generationName'}">
          <table :style="{'min-width':stage.setting.system.autoColumnWidth[0]*column.length+stage.setting.system.autoColumnWidth[1]}">
            <thead class="head-token">
              <tr>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody class="bdLight-bottom_E emptyToken_EE textCut_EE">
              <tr v-for="(item, index) in data" :key="index">         
                <td :title="item.networkStatus?getTypeText(item.networkStatus, 'connectStatusForchild').name:'--'"><div class='dian' :style="{'background-color':getTypeText(item.networkStatus, 'connectStatusForchild').color}"></div>{{item.networkStatus?getTypeText(item.networkStatus, 'connectStatusForchild').name:'--' }}</td>
                <td :title="item.warningStatus?getTypeText(item.warningStatus,'alarmStateChild').name:'--'"><div class='dian' :style="{'background-color':getTypeText(item.warningStatus, 'alarmStateChild').color}"></div>{{item.warningStatus?getTypeText(item.warningStatus, 'alarmStateChild').name:'--'}}</td>
                <td :title="item.generationPower!==null ? floatFix(item.generationPower/1000,2,null,null,true):'--'">{{item.generationPower!==null ? floatFix(item.generationPower/1000,2,null,null,true):'--'}}</td>
                <td :title="item.generationValue!==null ? floatFix(item.generationValue,2,null,null,true):'--'">{{item.generationValue!==null ? floatFix(item.generationValue,2,null,null,true):'--'}}</td>
                <td :title="item.generationUploadTotalOffset!==null ? floatFix(item.generationUploadTotalOffset,2,null,null,true):'--'">{{item.generationUploadTotalOffset!==null ? floatFix(item.generationUploadTotalOffset,2,null,null,true):'--'}}</td>
                <td :title="item.fullPowerHoursDay!==null ? floatFix(item.fullPowerHoursDay,2,null,null,true):'--'">{{item.fullPowerHoursDay!==null ? floatFix(item.fullPowerHoursDay,2,null,null,true):'--'}}</td>
                <td v-if="!item.generationCapacity">--</td>
                <td v-else><Progress :percent='floatFix(item.generationCapacity*100,2)+"%" '></Progress></td>
                <td :title="item.installedCapacity!==null ? floatFix(item.installedCapacity,2,null,null,true):'--'">{{item.installedCapacity!==null ? floatFix(item.installedCapacity,2,null,null,true):'--'}}</td>
              </tr>
            </tbody>
          </table>
        </div>
            <!--
          -->
      </div>
  </div>
 <div class="tableBatch bgContent cSub tra-fast myListHeight01"
           :class="{disable:!data.length}">
        <Pagination class="ml2x"
                    :pagination="pagination"
                    :getList="getList"
                    ref="Pagination"></Pagination>
      </div>
</div>
</template>
<script>
import { getLanguageStr } from '@/util/language'
import Progress from '@/components/common/Progress.vue'
import {mixin} from './commonMethds'
import * as lib from '@/util/lib.js'
import Pagination from '@/components/common/ui/Pagination.vue'
import Help from '@/components/common/Help.vue'
export default {
  name: 'generation',
  mixins: [mixin],
  components: {Progress, Pagination, Help},
  data () {
    return {
      stage,
      floatColumn: new Array(1),
      column: new Array(6),
      data: [],
      name: 'ASC',
      generationPower: '',
      generationValue: '',
      installedCapacity: '',
      generationUploadTotalOffset: '',
      fullPowerHoursDay: '',
      generationCapacity: '',
      pagination: {} // 分页数据
    }
  },
  // props: {
  //   stationId: {
  //     type: String,
  //     default: ''
  //   },
  //   requestData: {
  //     type: Object
  //   }
  // },
  methods: {
    getLanguageStr,
    getTypeText: lib.getTypeText,
    floatFix: lib.floatFix,
    sortList (name) {
      switch (name) {
        case 'name':
          this.name === 'ASC' ? this.name = 'DESC' : this.name = 'ASC'
          this.generationUploadTotalOffset = ''
          this.generationValue = ''
          this.generationPower = ''
          this.generationCapacity = ''
          this.installedCapacity = ''
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.name,
            'order.property': 'name'
          }
          break
        case 'generationCapacity':
          this.name = ''
          this.generationUploadTotalOffset = ''
          this.generationValue = ''
          this.generationPower = ''
          this.installedCapacity = ''
          this.generationCapacity === 'ASC' ? this.generationCapacity = 'DESC' : this.generationCapacity = 'ASC'
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.generationCapacity,
            'order.property': 'generation_capacity'
          }
          break
        case 'generationValue':
          this.name = ''
          this.generationUploadTotalOffset = ''
          this.generationValue === 'ASC' ? this.generationValue = 'DESC' : this.generationValue = 'ASC'
          this.generationPower = ''
          this.generationCapacity = ''
          this.installedCapacity = ''
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.generationValue,
            'order.property': 'generation_value'
          }
          break
        case 'generationPower':
          this.name = ''
          this.generationUploadTotalOffset = ''
          this.generationValue = ''
          this.generationPower === 'ASC' ? this.generationPower = 'DESC' : this.generationPower = 'ASC'
          this.generationCapacity = ''
          this.installedCapacity = ''
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.generationPower,
            'order.property': 'generation_power'
          }
          break
        case 'generationUploadTotalOffset':
          this.name = ''
          this.generationValue = ''
          this.generationPower = ''
          this.generationCapacity = ''
          this.generationUploadTotalOffset === 'ASC' ? this.generationUploadTotalOffset = 'DESC' : this.generationUploadTotalOffset = 'ASC'
          this.installedCapacity = ''
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.generationUploadTotalOffset,
            'order.property': 'generation_upload_total_offset'
          }
          break
        case 'installedCapacity':
          this.name = ''
          this.generationValue = ''
          this.generationPower = ''
          this.generationCapacity = ''
          this.generationUploadTotalOffset = ''
          this.installedCapacity === 'ASC' ? this.installedCapacity = 'DESC' : this.installedCapacity = 'ASC'
          this.fullPowerHoursDay = ''
          this.requestParams = {
            'order.direction': this.installedCapacity,
            'order.property': 'installed_capacity'
          }
          break
        case 'fullPowerHoursDay':
          this.name = ''
          this.generationValue = ''
          this.generationPower = ''
          this.generationCapacity = ''
          this.generationUploadTotalOffset = ''
          this.installedCapacity = ''
          this.fullPowerHoursDay === 'ASC' ? this.fullPowerHoursDay = 'DESC' : this.fullPowerHoursDay = 'ASC'
          this.requestParams = {
            'order.direction': this.fullPowerHoursDay,
            'order.property': 'full_power_hours_day'
          }
          break
      } 
      this.getList()
    }
    // getList () {
    //   getAllchild(this.stationId, this.requestData).then(data => {
    //     console.log(data)
    //   })
    // }
  },
  mounted () {
    // this.getList()
    lib.setScroll($(this.$el).find("[scroll]"));
  }
}
</script>
<style lang="scss" scoped>
.dian{
  width: .5em;
  height: .5em;
  border-radius: 50%;
  display: inline-block;
  margin-right: 1em;
  margin-top: .4em;
}
</style>



// WEBPACK FOOTER //
// src/view/maintain/light/plant/part/Generation.vue